import {
	Component,
	ComponentFactoryResolver,
	Inject,
	Input,
	OnInit,
	Type,
	ViewChild,
	ViewContainerRef
} from '@angular/core';
import { AbstractWrapper } from '../abstract-wrapper.class';
import { LuTypeaheadChipLabelComponent } from '../lu-typeahead-chip-label/lu-typeahead-chip-label.component';
import { ILuTypeaheadCustomChip, LuTypeaheadType } from '../lu-typeahead.models';
import { LuTypeaheadCustomChip } from './lu-typeahead-custom-chip';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-typeahead-chip-wrapper',
	template: ` <ng-template #chipComponent></ng-template>`
})
export class LuTypeaheadChipWrapperComponent extends AbstractWrapper implements OnInit {
	@Input() options: any;
	@Input() data: any;
	@Input() closeCallback;
	@Input() index;
	@Input() chipsLength;
	@ViewChild('chipComponent', { read: ViewContainerRef, static: true }) containerRef: ViewContainerRef;

	constructor(@Inject(ComponentFactoryResolver) protected componentFactoryResolver: ComponentFactoryResolver) {
		super(componentFactoryResolver);
	}

	ngOnInit(): void {
		this.containerRef.clear();
		let type: Type<any>;
		switch (this.options.type) {
			case LuTypeaheadType.PRIMARY_SECONDARY: {
				type = LuTypeaheadChipLabelComponent;
				const item = this.createComponent<LuTypeaheadChipLabelComponent>(this.containerRef, type);
				item.instance.options = this.options;
				item.instance.data = this.data;
				item.instance.close = this.closeCallback;
				item.instance.index = this.index;
				item.instance.chipsLength = this.chipsLength;
				break;
			}
			case LuTypeaheadType.CUSTOM: {
				type = this.options.itemComponent;
				const item = this.createComponent<LuTypeaheadCustomChip<ILuTypeaheadCustomChip>>(this.containerRef, type);
				item.instance.data = this.data;
				item.instance.interface = this.options.interface;
				item.instance.close = this.closeCallback;
				item.instance.index = this.index;
				item.instance.chipsLength = this.chipsLength;
				break;
			}
			default: {
				console.log('chip type not recognized');
				break;
			}
		}
	}
}
